import { Button } from '@mui/material';
import { PrimaryButton } from '../../../../components/style/ButtonStyle';
import { ApiResultModal } from '../../../../components/modal/ApiResultHandler';
import { useNavigate } from 'react-router-dom';

export function EditUserButton({
  isDesktop,
  onSubmit,
  putUserResult,
  userId,
}: any) {
  const navigate = useNavigate();
  return (
    <>
      {isDesktop ? (
        <PrimaryButton sx={{ width: 130, height: 40 }} onClick={onSubmit}>
          수정
        </PrimaryButton>
      ) : (
        <Button variant="text" onClick={onSubmit}>
          수정
        </Button>
      )}

      <ApiResultModal
        apiResult={putUserResult}
        successTitle="수정됐습니다."
        successCode={200}
        onSuccessClose={() => {
          navigate(`/users/${userId}`);
        }}
        failTitle="관리자에게 문의해주세요."
        ErrorCodeTable={{
          PAYLOAD_INVALID: { title: '입력값을 확인해주세요' },
          DUPLICATE_EMAIL: { title: '이미 등록된 아이디입니다.' },
        }}
      />
    </>
  );
}
